exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "a:hover .ui-grid {\n  background: #f5f5f5; }\n\n.ui-grid.selected {\n  background: #0275d8 !important;\n  color: white !important; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/component/aFormSelect/aFormSelect.component.scss
// module id = 460
// module chunks = 0